<template>
  <div class="main">
    <div class="order-status">
      <span>订单状态:{{ statusArray[customOrder.status] }}</span>
    </div>
    <van-cell-group>
      <van-cell title="买家" />
      <van-cell title-style="display:flex;flex-direction:row;" center>
        <template #title>
          <van-image
            round
            fit="contain"
            height="40"
            :src="customOrder.headPortrait"
          />
          <van-cell
            style="padding:0 10px 0 10px"
            :title="customOrder.userName"
            :label="customOrder.userPhone"
            center
          >
            <template #right-icon>
              <van-icon name="phone" size="20px" />
            </template>
          </van-cell>
        </template>
        <template #right-icon>
          <van-icon name="comment" size="20px" />
        </template>
      </van-cell>
    </van-cell-group>

    <div class="order-detail">
      <van-cell-group
        :border="false"
        inset
        style="margin:0;border-radius:8px"
        v-if="customOrder.status === 1 && customOrder.printStatus !== null"
      >
        <van-cell
          :title="'打印排序 ' + customOrder.printStatus"
          :border="false"
        ></van-cell>
        <van-cell :border="false">
          <template #title>
            <span>打印状态&#32;</span>
            <span v-if="customOrder.printStatus === 0" class="print-status"
              >正在打印</span
            >
            <span v-if="customOrder.printStatus === 1" class="print-status"
              >已完成</span
            >
            <span v-if="customOrder.printStatus === 2" class="print-status"
              >已取消</span
            >
            <span v-if="customOrder.printStatus === 3" class="print-status"
              >打印失败</span
            >
            <span v-if="customOrder.printStatus === 4" class="print-status"
              >等待打印</span
            >
            <span v-if="customOrder.printStatus === 5" class="print-status"
              >打印暂停</span
            >
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group inset style="margin:10px 0 0 0;border-radius:8px">
        <van-cell
          title="打印商品信息"
          title-style="font-size:14px;color:#969799"
          :value="'共' + listCount + '件商品'"
          label-class="detail-label"
          style="display:flex;flex-direction: column;"
        >
          <template #label>
            <van-cell
              :border="false"
              :center="true"
              style="padding:0;margin-top:12px;"
              v-if="customOrder.boxType == '1'"
              title-style="display:flex;align-items:center;flex-direction:row;font-size:14px;min-width:90%"
            >
              <template #title>
                <van-image
                  fit="contain"
                  height="67"
                  width="106"
                  :src="customOrder.giftBoxPicture"
                  style="margin-right:11px"
                />
                定制礼盒
              </template>
            </van-cell>
            <van-cell-group :border="false">
              <van-cell
                v-for="item in customOrder.list"
                :border="false"
                :key="item.index"
                :center="true"
                :style="
                  (customOrder.boxType == '1'
                    ? 'padding:0 0 0 20px;'
                    : 'padding:0;') + 'margin-top:12px;'
                "
                title-style="display:flex;align-items:center;flex-direction:row;font-size:14px;min-width:90%"
                :value="'x' + item.count"
                value-class="detail-label-value"
              >
                <template #title>
                  <van-image
                    fit="contain"
                    height="47"
                    width="86"
                    :src="item.nciUrl"
                    style="margin-right:11px"
                  />
                  {{ item.productName }}
                </template>
              </van-cell>
            </van-cell-group>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group
        :border="false"
        inset
        style="margin:8px 0 0 0;border-radius:8px"
      >
        <van-cell
          :border="false"
          title="打印编号"
          :value="customOrder.pdeNum"
          title-style="min-width:60%"
          value-class="value"
        ></van-cell>
        <van-cell
          :border="false"
          title="创建时间"
          :value="customOrder.pdeCreateTime"
          title-style="min-width:60%"
          value-class="value"
        ></van-cell>
        <van-cell
          v-if="customOrder.status !== 0"
          :border="false"
          title="接单时间"
          :value="customOrder.orderTime"
          title-style="min-width:60%"
          value-class="value"
        ></van-cell>
        <van-cell
          v-if="customOrder.status !== 0 && customOrder.printStatus === 1"
          :border="false"
          title="打印完成"
          :value="customOrder.completeTime"
          title-style="min-width:60%"
          value-class="value"
        ></van-cell>
      </van-cell-group>
    </div>
    <div class="btnContent">
      <van-button
        class="btn"
        plain
        type="default"
        v-if="customOrder.status != 3"
        size="small"
        :data-img="customOrder.previewImgUrl"
        @click="previewImg"
        >打印预览</van-button
      >
      <van-button
        class="btn"
        v-if="customOrder.status == 0"
        plain
        type="default"
        size="small"
        :data-id="customOrder.productionDemandOrderId"
        data-msg="无法制作"
        :data-active="3"
        @click="sumbitAction"
        >无法制作</van-button
      >
      <van-button
        class="btn"
        v-if="customOrder.status == 0"
        type="default"
        size="small"
        color="#C99B54"
        :data-active="0"
        data-msg="开始制作"
        :data-id="customOrder.productionDemandOrderId"
        @click="sumbitAction"
        >开始制作</van-button
      >

      <van-button
        class="btn"
        v-if="customOrder.status == 1"
        plain
        type="default"
        size="small"
        :data-active="2"
        data-msg="完成制作"
        :data-id="customOrder.productionDemandOrderId"
        @click="sumbitAction"
        >制作完成</van-button
      >
      <van-button
        class="btn"
        v-if="customOrder.status == 1 && customOrder.transmissionStatus == '2'"
        plain
        type="default"
        size="small"
        :data-no="customOrder.pdeNum"
        @click="printCustom"
        >定制打印</van-button
      >
      <van-button
        v-if="
          customOrder.status == 1 &&
            customOrder.printStatus == 4 &&
            customOrder.transmissionStatus != '2'
        "
        plain
        type="default"
        size="small"
        ><van-loading type="spinner">上传中,请稍后刷新页面...</van-loading>
      </van-button>
    </div>
  </div>
</template>

<script>
import "../../assets/css/customDetail.less";
import { queryPost, apiPost } from "@/api/common";
import { downloadIamge } from "@/utils/tool.js";
import { ImagePreview, Dialog } from "vant";
// 引入vant组件库
export default {
  name: "CustomDetail",
  data() {
    return {
      shopInfo: "",
      orderId: "",
      statusArray: ["待接单", "制作中", "已完成", "无法制作"],
      customOrder: "",
      printStatusArray: [
        "正在打印",
        "已完成",
        "已取消",
        "打印失败",
        "等待打印",
        "打印暂停"
      ],
      showNotify: true,
      listCount: 0,
      timerMax: new Map()
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.getCustomOrder();
  },
  mounted() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tabHeight = h - 40;
  },
  methods: {
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.orderId = this.$route.query.id;
    },
    getCustomOrder() {
      let _this = this;
      let url = "/api/productionDemandOrderController/findById";
      let data = {
        id: parseInt(this.orderId)
      };
      queryPost(url, data).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          let r = _data.data.results;
          if (r.status == 1 && r.transmissionStatus != 2) {
            r.uploadFinish = false;
            r.timer = setInterval(function() {
              _this.checkFileUploadFinish(r);
            }, 4000);
          }

          let list = r.list;
          for (let i = 0; i < list.length; i++) {
            list[i].des = eval("(" + list[i].designInfos + ")");
          }
          r.list = list;
          _this.customOrder = r;

          _this.customOrder.list.forEach(item => {
            _this.listCount = _this.listCount + item.count;
          });
          // 将后端传入的日期通过自定义方法格式化
          _this.customOrder.orderTime = _this.formatTime(
            _this.customOrder.orderTime
          );
          _this.customOrder.pdeCreateTime = _this.formatTime(
            _this.customOrder.pdeCreateTime
          );
          _this.customOrder.completeTime = _this.formatTime(
            _this.customOrder.completeTime
          );

          //   _this.setCustomDatas(this.orderStatus, _data.data.results);
        } else {
          Dialog.alert({
            title: "提示",
            message: _data.msg,
            theme: "round-button"
          });
        }
      });
    },
    // 格式化日期
    formatTime(time) {
      var date = new Date(time).toJSON();
      return new Date(+new Date(date) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    //点击动作
    sumbitAction(e) {
      let data = e.target.dataset;
      let _this = this;
      Dialog.confirm({
        title: "提醒",
        message: "确定" + data.msg
      }).then(() => {
        _this.updateOrderStatus(data);
      });
    },
    updateOrderStatus(data) {
      let _this = this;
      let url = "/api/productionDemandOrderController/updateStatus";
      let params = {
        id: data.id,
        operateType: data.active
      };
      if (this.orderStatus) {
        data.status = parseInt(this.orderStatus);
      }
      apiPost(url, params).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          _this.$toast.success("成功");
          _this.getCustomOrder();
        } else {
          Dialog.alert({
            title: "提示",
            message: _data.msg,
            theme: "round-button"
          });
        }
      });
    },
    downs(e) {
      //下载素材
      let data = e.target.dataset;
      downloadIamge(data.imgurl, data.id);
      ImagePreview([data.img]);
      Dialog.alert({
        title: "提示",
        message: "如无下载提示,请长按图片下载"
      });
    },
    previewImg: function(e) {
      let data = e.target.dataset;
      ImagePreview([data.img]);
    },
    //定制打印
    printCustom: function(e) {
      let _this = this;
      let data = e.target.dataset;
      let url = "/order/productionDemandOrderController/startMaking";
      let params = {
        productionDemandOrderNo: data.no
      };
      Dialog.confirm({
        title: "提示",
        message: "请确认盒子是否摆放正确！"
      }).then(() => {
        _this.$toast.loading({
          duration: 0, // 持续展示 toast,永远不会关闭
          mask: true, // 整体添加一个遮罩
          message: "打印中..."
        });
        queryPost(url, params).then(resp => {
          let _data = resp.data;
          let _code = _data.code;
          if (_code == "0000") {
            _this.$toast.success();
            _this.getCustomOrder();
          } else {
            let errorMsg = _data.msg;
            if (_data.msg == "Connection refused (Connection refused)") {
              errorMsg = "店铺打印机/打印软件/或打印服务未开启,请检查!";
            }
            Dialog.alert({
              title: "提示",
              message: errorMsg,
              theme: "round-button"
            });
          }
        });
      });
    },
    //检验ftp文件是否传输完成
    checkFileUploadFinish: function() {
      let _this = this;
      let data = this.customOrder;
      const timer = data.timer;
      let count = this.timerMax.get(timer);
      if (!count) {
        count = 0;
      }
      if (count >= 20) {
        console.log("定时任务执行超过20次,中止了");
        clearInterval(data.timer);
        this.timerMax.delete(timer);
        return;
      }
      count = count + 1;
      this.timerMax.set(timer, count);

      let url = "/api/productionDemandOrderController/findById";
      let param = {
        id: parseInt(this.orderId)
      };
      queryPost(url, param).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          let r = _data.data.results;
          if (r.transmissionStatus == "2") {
            data.uploadFinish = true;
            _this.customOrder.transmissionStatus = 2;
            clearInterval(data.timer);
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  .order-status {
    padding: 10px;
    width: 100%;
    font-size: 16px;
    color: #fff;
    background-image: -webkit-linear-gradient(top, #a86f32 0%, #f6cc64 100%);
    background-image: linear-gradient(top, #a86f32 0%, #f6cc64 100%);
    height: 46px;
    box-sizing: border-box;
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .order-detail {
    padding: 8px;
    margin-bottom: 73px;
    .print-status {
      color: #be9b5c;
    }

    .detail-label {
      width: 100%;
    }
    .value {
      text-align: left;
    }
  }
  .btnContent {
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    height: 73px;
    padding-right: 9px;
    bottom: 0;
    background-color: #fff;
    text-align: right;
    line-height: 58px;
    .btn {
      margin: 0 10px;
      height: 40px;
      border-radius: 4px;
    }
  }
}
</style>
